import {useQuery} from '@tanstack/react-query';
import {assetManagersApi} from '@/api-requests/asset-managers';

// const assetManagerCollection = collection(db, ASSET_MANAGER_COLLECTION);
// const assetManagerQuery = query(assetManagerCollection).withConverter(
//   AssetManagerConverter
// );

export const useAssetManagers = () => {
  return useQuery({
    queryKey: ['asset-managers'],
    queryFn: () => {
      return assetManagersApi.getAssetManagers();
    },
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
  });
};
